/**
 * Shape helpers for /user/profile ↔ keyon GetSelfProfile / UpdateSelfProfile.
 * Pure — no axios, no Vue. Keep FE field names stable even if keyon adds columns.
 */

export function emptySelfProfile() {
  return {
    accountnumber: '',
    unique_ID: '',
    account_type: '',
    username: '',
    firstName: '',
    lastName: '',
    dob: '',
    gender: '',
    npi: '',
    phone1: '',
    phone1Type: 0,
    phone2: '',
    phone2Type: 0,
    email: '',
    communicationPreference: 'Email',
    address: '',
    addr2: '',
    city: '',
    state: '',
    zip: '',
    maddr: '',
    maddr2: '',
    mcity: '',
    mstate: '',
    mzip: '',
    can_edit_gender: false,
    can_edit_npi: false,
  };
}

const PREF_VALUES = ['Email', 'SMS', 'Phone', 'All'];

function normalizePreference(raw) {
  const pref = String(raw || '').trim();
  const match = PREF_VALUES.find((v) => v.toLowerCase() === pref.toLowerCase());
  return match || 'Email';
}

/** Coerce a keyon GetSelfProfile data object into the page's working model. */
export function normalizeSelfProfile(raw) {
  const base = emptySelfProfile();
  if (!raw || typeof raw !== 'object') return base;
  const out = { ...base };
  Object.keys(base).forEach((key) => {
    if (raw[key] === undefined || raw[key] === null) return;
    if (key === 'phone1Type' || key === 'phone2Type') {
      out[key] = Number(raw[key]) || 0;
      return;
    }
    if (key === 'can_edit_gender' || key === 'can_edit_npi') {
      out[key] = !!raw[key];
      return;
    }
    if (key === 'communicationPreference') {
      out[key] = normalizePreference(raw[key]);
      return;
    }
    out[key] = String(raw[key]);
  });
  if (out.dob && out.dob.indexOf(' ') !== -1) {
    out.dob = out.dob.slice(0, 10);
  }
  out.communicationPreference = normalizePreference(out.communicationPreference);
  return out;
}

/** Body.profile for UpdateSelfProfile — no identity keys. */
export function buildSelfProfileWritePayload(profile) {
  const p = normalizeSelfProfile(profile);
  return {
    firstName: p.firstName,
    lastName: p.lastName,
    dob: p.dob,
    gender: p.gender,
    npi: p.npi,
    phone1: p.phone1,
    phone1Type: p.phone1Type,
    phone2: p.phone2,
    phone2Type: p.phone2Type,
    communicationPreference: p.communicationPreference,
    address: p.address,
    addr2: p.addr2,
    city: p.city,
    state: p.state,
    zip: p.zip,
    maddr: p.maddr,
    maddr2: p.maddr2,
    mcity: p.mcity,
    mstate: p.mstate,
    mzip: p.mzip,
  };
}
